export default __webpack_public_path__ + "static/DMSans-Regular-6abbf72e41401fb32c38e6759d3d36c7.woff";